import { Modal, PrimaryButton, Stack } from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Link,
  Text,
} from "@certn/cascadia-react";
import { AdjudicationBetaBadge } from "../../../../components/adjudication-beta/AdjudicationBetaBadge";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "adjudication-beta-modal-dismissed";

export function AdjudicationBetaModal() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(
    localStorage.getItem(STORAGE_KEY) !== "true"
  );

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  const handleStartExploring = () => {
    setIsOpen(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} testID="adjudication-beta-modal">
      <Dialog width="560px">
        <DialogHeader onClose={handleClose}>
          <Stack orientation="horizontal" gap="space-2" align="center">
            <Text style="global/modal-header">
              {t("Welcome to Adjudication")}
            </Text>
            <AdjudicationBetaBadge />
          </Stack>
        </DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/modal-header-small">
              {t(
                "Adjudication helps your team make consistent, confident decisions across background checks."
              )}
            </Text>
            <Text style="global/body-primary">
              {t(
                "Create scoring rubrics, apply clear rules, and streamline how you review cases."
              )}
            </Text>
            <Text style="global/body-primary">
              {t(
                "This feature is currently in Beta, so you may notice ongoing updates as we refine the experience and add new checks."
              )}{" "}
              <Link
                testID="learn-more-link"
                href="https://portal.certn.co/hc/en-us/articles/47444037282835-Beta-Features"
                isNewTab
                linkStyle="monochrome"
              >
                {t("Learn more")}
              </Link>
            </Text>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <PrimaryButton
            onPress={handleStartExploring}
            testID="start-exploring-button"
          >
            {t("Start exploring")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
